import { Box, Tooltip } from "@mui/material";
import { Fragment } from "react";
import FlexBox from "../../../components/layouts/Flexbox";
import {
  ProjectCardActionButton,
  ProjectCardActionIcon,
  ProjectCardActionLabel,
} from "./project-card.styles";

export type ProjectCardAction = {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
  variant?: "default" | "confirmed";
  disabled?: boolean;
  tooltip?: string;
};

type ProjectCardActionsBarProps = {
  actions: ProjectCardAction[];
};

export function ProjectCardActionsBar({ actions }: ProjectCardActionsBarProps) {
  if (!actions.length) return null;

  const isCompactLayout = actions.length <= 2;

  return (
    <FlexBox
      borderTop={1}
      borderColor="divider"
      alignItems="stretch"
      width="100%"
      mt="auto"
      flexShrink={0}
    >
      {actions.map((action, index) => {
        const isConfirmed = action.variant === "confirmed";

        const buttonContent = (
          <>
            <ProjectCardActionIcon compact={isCompactLayout}>
              {action.icon}
            </ProjectCardActionIcon>
            <ProjectCardActionLabel compact={isCompactLayout}>
              {action.label}
            </ProjectCardActionLabel>
          </>
        );

        const actionButton = (
          <ProjectCardActionButton
            compact={isCompactLayout}
            confirmed={isConfirmed}
            disabled={action.disabled || isConfirmed}
            onClick={(event) => {
              event.stopPropagation();
              action.onClick?.();
            }}
            sx={action.tooltip ? { width: "100%" } : undefined}
          >
            {buttonContent}
          </ProjectCardActionButton>
        );

        return (
          <Fragment key={`${action.label}-${index}`}>
            {index > 0 && (
              <Box
                width="1px"
                alignSelf="stretch"
                bgcolor="divider"
                flexShrink={0}
              />
            )}
            {action.tooltip ? (
              <Tooltip title={action.tooltip} placement="top" arrow>
                <span style={{ display: 'flex', flex: 1 }}>
                  {actionButton}
                </span>
              </Tooltip>
            ) : (
              actionButton
            )}
          </Fragment>
        );
      })}
    </FlexBox>
  );
}
